import QRCode from 'qrcode';
import type { QrType } from '@flashcard/shared';

// Rohwert → QR-Inhalt (abhängig vom Typ)
export function buildQrValue(type: QrType, value: string): string {
  switch (type) {
    case 'website':
      return value;
    case 'whatsapp':
      return `https://wa.me/${value.replace(/\D/g, '')}`;
    case 'email':
      return `mailto:${value}`;
    case 'phone':
      return `tel:${value.replace(/\s/g, '')}`;
    case 'google-review':
      return value;
    default:
      return value;
  }
}

// Erzeugt eine Data-URL (PNG) für die QR-Anzeige/PDF-Einbettung
export async function generateQrDataUrl(value: string): Promise<string> {
  return QRCode.toDataURL(value, { margin: 1, width: 512 });
}
